export enum EnumBudgetStatus {
    New = 0,
    Approval = 1,
    Approved = 2,
    Rejected = 3,
    Cancelled = 4,
    Replaced = 5
}